import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './App.css';
import 'antd/dist/antd.css';
import '@fortawesome/fontawesome-free/css/all.css';
import Order from './components/order';
import Mp from './components/mp';
import Statistics from './components/statistics';
import Login from './components/login';
import Auth from './components/auth';
import Meeting from './components/meetingOrder'

function App() {
  let current_version = "20250101"
  let version = window.localStorage.getItem("version");
  if (version != current_version) {
    window.localStorage.setItem("version", current_version);
    window.location.reload();
  }
  return (
      <Router>
        <div className="App">
          <Route exact path="/" render={props => <Order {...props} ckey='1' />} />
          <Route exact path='/order' render={props => <Order {...props} ckey='1' />} />
          <Route exact path='/xuetangx' render={props => <Order {...props} ckey='45e38718e7518bcc8c3e8e28a74aff62' />} />
          <Route exact path='/keg' render={props => <Order {...props} ckey='keg' />} />
          <Route exact path='/mp' render={props => <Mp {...props} ckey='1' />} />
          <Route exact path='/statistics' component={Statistics} />
          <Route exact path='/login' component={Login} />
          <Route exact path='/auth' component={Auth} />
          <Route exact path='/meeting' render={props => <Meeting {...props} />} />
        </div>
      </Router>
  );
}

export default App;